
export const BUYER_COMMISION = 1;
export const SELLER_COMMISION = 0.5;